export const MainColors = {
    primary: '#00ABF5',
    secondary: '#26CF86',
    darkGray: '#212121',
    mediumGray: '#767676',
    lightGray: '#C1C1C1',
    faintGray: '#E6E8E6',
    grayBackground: '#F2F2F2',
    danger: '#F71735',
    dimmedBackground: 'rgba(0, 0, 0, 0.8)'
};

export const Status = {
    active: '#3D9970',
    pending: '#EA9010',
    cancelled: '#FF101F',
    complete: '#009DE0'
};

export const PieChartColors = ['#23D1BA', '#57AEE2', '#7A3FDE', '#C93FDE', '#E462B5', '#DE3F54', '#DE7A3F', '#DEC93F', '#73E462']
